export const turnLinkGreen = {backgroundColor:"var(--beak-green)", color:"var(--background-beige)"};